import { useState, useCallback } from "react"
import { useStaticQuery, graphql } from "gatsby"

import { useCore } from "./useCore"
import { useApp } from "./useApp"

export const useAnnouncement = () => {
  const {
    helpers: { storage },
  } = useCore()

  const {
    config: {
      settings: { keys },
    },
  } = useApp()

  const { announcements } = useStaticQuery(graphql`
    query ANNOUNCEMENTS {
      announcements: sanitySettingAnnouncement {
        duration
        announcements {
          title
          icon {
            asset {
              url
            }
          }
          link {
            link
            external
          }
          mobiletitle
          mobileicon {
            asset {
              url
            }
          }
          mobilelink {
            link
            external
          }
        }
        textColour {
          hex
        }
        announcementbarBgColour {
          hex
        }
      }
    }
  `)
  const [show, setShow] = useState(storage.get(keys?.announcement) !== "hidden")
  const tColor = { hex: "#ffffff" }
  const bColor = { hex: "#d84233" }
  const items = announcements?.announcements || []
  const duration = announcements?.duration || 5
  const textColor = announcements?.textColour || tColor
  const barBGcolor = announcements?.announcementbarBgColour || bColor

  const hide = useCallback(() => {
    storage.set(keys?.announcement, "hidden")
    setShow(false)
  }, [keys?.announcement, storage])

  return {
    items,
    duration,
    textColor,
    barBGcolor,
    show,
    hide,
  }
}
